import React, { useEffect, useRef, useState } from "react";
import PlusIcon from "../../assets/icons/plus-circle-white.svg";
import DeleteIcon from "../../assets/icons/DeleteIcon.svg";
import DelIcon from "../../assets/icons/DeleteIconCircle.svg";
import searchIcon from "../../assets/icons/search.svg";
import CheckboxIcon from "../../assets/images/CheckboxWhite.svg";
import CheckboxBlueIcon from "../../assets/images/CheckboxBlue.svg";
import DeletePopUp from "../Dailogs/DeletePopUp";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import { formattedCurrency } from "../../utils/helpers/calculateTime";
import { DeleteComposeProduct } from "../../redux/actions/action";
import { useDispatch, useSelector } from "react-redux";

const ProductComposition = ({
  totalQty,
  setTotalQty,
  setCompositionData,
  compositionData,
  listData,
  setListData,
  clientSearch,
  setClientSearch,
  FetchTranslationList,
}) => {
  const location = useLocation();
  const dispatch = useDispatch();

  const productPartId = location?.state?.productPartId;
  const [addPartModal, setAddPartModal] = useState(false);
  const [editQtyModal, setEditQtyModal] = useState(false);
  const [editQty, setEditQty] = useState();
  const qtyRef = useRef(null);
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    function handleClickOutside(event) {
      if (qtyRef.current && !qtyRef.current.contains(event.target)) {
        setEditQty();
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [qtyRef]);

  const handleDeleteDocumentFun = () => {
    setEditQtyModal(false);
  };
  const updateCompositionData = () => {
    // Create a set of partIDs from listData for efficient matching
    const listDataPartIDs = new Set(listData.map((item) => item.partID));

    // Update isChecked in compositionData based on listData partID
    const updatedCompositionData = compositionData?.map((item) => ({
      ...item,
      isChecked: listDataPartIDs.has(item.partID),
    }));

    // Set the updated compositionData state
    setCompositionData(updatedCompositionData);
  };

  // Call the function to update compositionData
  useEffect(() => {
    updateCompositionData();
  }, [listData]);

  const handleCheckboxChange = (partID) => {
    // Clean up unitCost values in compositionData and convert to numbers
    const cleanedCompositionData = compositionData.map((item) => {
      const cleanedUnitCost =
        typeof item.unitCost === "string"
          ? Number(item.unitCost.replace(",", "."))
          : item.unitCost;
      return {
        ...item,
        unitCost: cleanedUnitCost,
      };
    });

    // Map compositionData to updatedData
    // const updatedData = cleanedCompositionData.map((item) =>
    //   item.partID === partID ? { ...item, isChecked: !item.isChecked } : item,
    // );

    const updatedData = cleanedCompositionData.map((item) => ({
      ...item,
      isChecked:
        item.partID === partID
          ? !listData.some((x) => x.partID === partID)
          : listData.some((x) => x.partID === item.partID),
    }));

    const updatedListData = updatedData.filter((data) => data.isChecked);
    setCompositionData(updatedData);
    // Preserve quantity and totalCost from the existing listData
    const updatedListDataWithQty = updatedListData.map((updatedItem) => {
      const existingItem = listData
        ? listData.find((item) => item.partID === updatedItem.partID)
        : undefined;
      return existingItem
        ? {
            ...updatedItem,
            unitCost: existingItem.unitCost,
            quantity: existingItem.quantity,
            totalCost: existingItem.totalCost,
          }
        : updatedItem;
    });

    setListData(updatedListDataWithQty);
  };

  const handleDeleteItem = (partID) => {
    const updatedData = listData.filter((item) => item.partID !== partID);
    setListData(updatedData);

    const updatedCompositionData = compositionData.map((item) =>
      item.partID === partID ? { ...item, isChecked: false } : item,
    );
    setCompositionData(updatedCompositionData);
  };

  const handleQtyChange = (val, partID) => {
    const updatedData = listData.map((item) =>
      item.partID === partID
        ? {
            ...item,
            quantity: val,
            totalCost:
              isNaN(+item.unitCost) || isNaN(+val) ? 0 : +item.unitCost * +val,
          }
        : item,
    );

    setListData(updatedData);

    // Recalculate and update the totalCost in state
    const updatedTotalCost = updatedData.reduce(
      (totalCost, item) => totalCost + item.totalCost,
      0,
    );
    setTotalQty(updatedTotalCost);
  };

  const parseEuropeanNumber = (value) => {
    if (typeof value === "string") {
      return Number(value.replace(",", "."));
    }

    return Number(value);
  };

  const renderTableDataRows = () => {
    return listData?.map((item, index) => (
      <tr
        key={item.partID}
        style={{ borderBottom: "1px dashed rgb(126, 126, 126)" }}
      >
        <td className="product-compo-title ps-5 py-2">{item.partCode}</td>
        <td className="product-compo-title py-2">{item.partName}</td>
        <td className="product-compo-title py-2 w-15 qty-input">
          {editQty !== index && (
            <span
              className="cursor-pointer"
              onClick={() => {
                if (productPartId) {
                  setEditQtyModal(true);
                }
                setEditQty(index);
              }}
            >
              {item?.quantity ? item?.quantity : 0}
            </span>
          )}
          {editQty === index && (
            <input
              autoFocus
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  setEditQty();
                }
              }}
              className="edit-qty"
              type="text"
              value={item.quantity || ""}
              min="0"
              pattern="\d+"
              onChange={(e) => handleQtyChange(e.target.value, item.partID)}
            />
          )}
        </td>
        <td className="product-compo-title py-2">
          {/* {item.unitCost ? formattedCurrency(item.unitCost) : 0} */}
          {item.unitCost
            ? formattedCurrency(parseEuropeanNumber(item.unitCost))
            : formattedCurrency(0)}
        </td>
        <td className="product-compo-title py-2">
          {/* {item.unitCost * item.quantity
            ? formattedCurrency(item.unitCost * item.quantity)
            : 0} */}

          {item.unitCost && item.quantity
            ? formattedCurrency(
                parseEuropeanNumber(item.unitCost) * item.quantity,
              )
            : 0}
        </td>

        <td className="product-compo-title py-2 ">
          <img
            src={DeleteIcon}
            alt=""
            className="cursor-pointer"
            onClick={() => {
              handleDeleteItem(item.partID);
              dispatch(
                DeleteComposeProduct({
                  ComposeProductId: item.composeproductid,
                }),
              );
            }}
          />
        </td>
      </tr>
    ));
  };

  const [clientSearch2, setClientSearch2] = useState("");

  return (
    <div>
      <div className="d-flex align-items-center justify-content-between py-3 ps-5">
        <div
          className="d-flex gap-2 pointer align-items-center"
          onClick={() => setAddPartModal(true)}
        >
          <img src={PlusIcon} alt="" />
          <span className="add-part">{t("Add Part")}</span>
        </div>
        <div className="d-flex gap-5  align-items-center">
          <span className="add-part-bold">
            {t("Total Parts")} : {listData?.length ?? 0}
          </span>
          <span className="add-part-bold me-4">
            {t("Total Parts Cost")} :{" "}
            {totalQty ? formattedCurrency(isNaN(totalQty) ? 0 : totalQty) : 0}
            {/* {formattedCurrency(
              listData?.reduce((total, item) => {
                const unitCost = parseEuropeanNumber(item.unitCost);
                const quantity = Number(item.quantity) || 0;

                return total + unitCost * quantity;
              }, 0),
            )} */}
          </span>
        </div>
      </div>
      <table className="w-100">
        <thead>
          <tr
            style={{
              background: "#F1F1F1 0% 0% no-repeat padding-box",
              borderRadius: "4px",
              opacity: "1",
              height: "30px",
            }}
          >
            <th className="add-part ps-5">{t("Part ID")}</th>
            <th className="add-part">{t("Part Name")}</th>
            <th className="add-part">{t("Qty")}</th>
            <th className="add-part">{t("Unit Cost")}</th>
            <th className="add-part">{t("Total Cost")}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>{renderTableDataRows()}</tbody>
      </table>
      {addPartModal && (
        <div className="add-part-modal">
          <div className="part-modal-header d-flex align-items-center justify-content-between">
            <span className="add-part-bold">
              {/* Parts */}
              {t("Parts")}
            </span>
            <div className="client-search-main-product">
              <input
                type="text"
                value={clientSearch2}
                style={{
                  width: "90%",
                  margin: "0 0 0 0.5rem",
                  fontSie: "14px",
                  fontWeight: clientSearch ? "400" : "300",
                  color: clientSearch ? "" : "black",
                }}
                // placeholder="Search"
                placeholder={t("Search")}
                className="search-style select-client-div"
                onChange={(e) => {
                  setClientSearch2(e.target.value);
                }}
              />
              <img alt="" className="mb-1 search_pop" src={searchIcon} />
            </div>
            <img
              src={DelIcon}
              alt=""
              className="cursor-pointer"
              onClick={() => setAddPartModal(false)}
            />
          </div>
          <div className="add-part-list">
            {compositionData
              ?.filter(
                (item) =>
                  item.partCode
                    ?.toLowerCase()
                    .includes(clientSearch2.toLowerCase()) ||
                  item.partName
                    ?.toLowerCase()
                    .includes(clientSearch2.toLowerCase()),
              )
              .map((item, index) => (
                <div
                  key={item.partID}
                  className="d-flex py-1 align-items-center"
                  style={{ borderTop: "1px dashed rgb(126, 126, 126)" }}
                >
                  <img
                    onClick={() => handleCheckboxChange(item.partID)}
                    className="plus-img me-5"
                    // src={item.isChecked ? CheckboxBlueIcon : CheckboxIcon}
                    src={
                      listData?.some(
                        (selectedItem) => selectedItem.partID === item.partID,
                      )
                        ? CheckboxBlueIcon
                        : CheckboxIcon
                    }
                    alt="check-item"
                  />
                  <span
                    className="product-compo-title"
                    style={{ minWidth: "30%" }}
                  >
                    {item.partCode}
                  </span>
                  <span className="product-compo-title">{item.partName}</span>
                </div>
              ))}
          </div>
        </div>
      )}
      {editQtyModal && (
        <DeletePopUp
          animation={true}
          handleDelete={handleDeleteDocumentFun}
          show={editQtyModal}
          onHide={() => {
            setEditQtyModal(false);
            setEditQty();
          }}
          title1={t("The quantity of the part will affect the future")}
          title2={t("stock composed product.")}
          title3={t("Do you want to proceed with the change?")}
          no={t("No")}
          yes={"Change"}
        />
      )}
    </div>
  );
};

export default ProductComposition;
